import { createContext, useContext } from "react";

import useOrganisationBasket from "@/hooks/organisations/useOrganisationBasket";

const OrganisationBasketContext = createContext();

export function OrganisationBasketProvider({ children }) {
  const api = useOrganisationBasket();
  return (
    <OrganisationBasketContext.Provider value={api}>{children}</OrganisationBasketContext.Provider>
  );
}

export function useOrganisationBasketContext() {
  return useContext(OrganisationBasketContext);
}
